export const sendEvent = (event, properties) => {
  if (!event) return;
  const e = JSON.stringify({
    'event': event,
    ...properties
  });
  parent.postMessage(`gtm/${e}`, '*');
}